// language=GraphQL
export const ALL_TEXT_WITH_ICON_BLOCKS_QUERY = `query Query($withImage: Boolean = false) {
  textWithIconBlocks: cmsTextWithIconBlocks {
    id
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    imagePosition
  }
}`

// language=GraphQL
export const SINGLE_TEXT_WITH_ICON_BLOCK_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  textWithIconBlock: cmsTextWithIconBlock(id: $id) {
    id
    title
    text
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    imagePosition
  }
}`

// language=GraphQL
export const CREATE_TEXT_WITH_ICON_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTextWithIconBlockInput, $withImage: Boolean = false) {
    textWithIconBlock: createCmsTextWithIconBlock(input: $input) {
      id
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imagePosition
    }
  }`

// language=GraphQL
export const UPDATE_TEXT_WITH_ICON_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTextWithIconBlockInput, $withImage: Boolean = false) {
    textWithIconBlock: updateCmsTextWithIconBlock(input: $input) {
      id
      title
      text
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imagePosition
    }
  }`

// language=GraphQL
export const DELETE_TEXT_WITH_ICON_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextWithIconBlockInput) {
    deleteCmsTextWithIconBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TEXT_WITH_ICON_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextWithIconBlockInput) {
    forceDeleteCmsTextWithIconBlock(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TEXT_WITH_ICON_BLOCKS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelTestimonials: Boolean = false) {
  groupedDependents: cmsTextWithIconBlockDependents(id: $id) {
    travelTestimonials @include(if: $withTravelTestimonials) {
      id
    }
  }
}`
